export const removeMarkdown = (markdown: string) => {
  const lines = markdown.split("\n");
  let inCodeBlock = false;

  const result = lines.map((line) => {
    if (line.startsWith("```")) {
      inCodeBlock = !inCodeBlock;
      return null;
    }

    if (inCodeBlock) {
      return line;
    }

    line = line.replace(/^[\s]*([-*+])\s+/, "• ");

    line = line.replace(
      /^(\s*)(\d+)\.\s+/,
      (_, spaces, num) => `${spaces}${num}. `
    );

    let prev;
    do {
      prev = line;
      line = line
        .replace(/(?<!\\)(?<!\*)\*{3}([^\n]*?[^*\n][^\n]*?)\*{3}(?!\*)/g, "$1")
        .replace(/(?<!\\)(?<!\*)\*{2}([^\n]*?[^*\n][^\n]*?)\*{2}(?!\*)/g, "$1")
        .replace(/(?<!\\)(?<!\*)\*([^\n]*?[^*\n][^\n]*?)\*(?!\*)/g, "$1")
        .replace(/(?<!\\)(?<!~)~~([^\n]*?[^~\n][^\n]*?)~~(?!~)/g, "$1")
        .replace(/(?<!\\)(?<!%)%%([^\n]*?[^%\n][^\n]*?)%%(?!%)/g, "$1")
        .replace(/(?<!\\)`([^\n`]+?)`/g, "$1")
        .replace(
          /(^|[^a-zA-Z0-9\\])(_{1,3})([^\n]+?)\2([^a-zA-Z0-9]|$)/g,
          (_, before, open, content, after) =>
            content !== open
              ? `${before}${content.trim()}${after}`
              : `${before}${open}${content}${open}${after}`
        )
        .replace(/\\(.)/g, "$1");
    } while (line !== prev);

    return line;
  });

  return result.filter(Boolean).join("\n").replace(/&#32;/g, " ");
};
